import { FORM_FIELDS, FORM_FIELDS_NAMES } from './new-application-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

export const APPLICATION_FEE_INPUTS = (t): IFormInputProps[] => ([
  {
    key: FORM_FIELDS.FEE_PERCENTAGE,
    fieldName: FORM_FIELDS.FEE_PERCENTAGE,
    label: t(FORM_FIELDS_NAMES.FEE_PERCENTAGE),
    placeholder: '0.00',
    inputType: InputType.Number,
    suffix: '%',
    additionalClasses: 'application-quick-view-fees-width',
    fakeInputAdditionalClass: 'application-quick-view-fees-width',
    required: true,
    tooltipText: t(FORM_FIELDS_NAMES.FEE_PERCENTAGE_TOOLTIP),
    isLabelIcon: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.FEE_AMOUNT,
    fieldName: FORM_FIELDS.FEE_AMOUNT,
    label: t(FORM_FIELDS_NAMES.FEE_AMOUNT),
    placeholder: '0.00',
    inputType: InputType.Number,
    suffix: 'USD',
    additionalClasses: 'application-quick-view-fees-width',
    fakeInputAdditionalClass: 'application-quick-view-fees-width',
    required: true,
    tooltipText: t(FORM_FIELDS_NAMES.FEE_AMOUNT_TOOLTIP),
    isLabelIcon: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.MIN_FEE_AMOUNT,
    fieldName: FORM_FIELDS.MIN_FEE_AMOUNT,
    label: t(FORM_FIELDS_NAMES.MIN_FEE_AMOUNT),
    placeholder: '0.00',
    inputType: InputType.Number,
    suffix: 'USD',
    additionalClasses: 'application-quick-view-fees-width',
    fakeInputAdditionalClass: 'application-quick-view-fees-width',
    required: true,
    tooltipText: t(FORM_FIELDS_NAMES.MIN_FEE_AMOUNT_TOOLTIP),
    isLabelIcon: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.RISK_FEE,
    fieldName: FORM_FIELDS.RISK_FEE,
    label: t(FORM_FIELDS_NAMES.RISK_FEE),
    placeholder: '0.00',
    inputType: InputType.Number,
    suffix: '%',
    additionalClasses: 'application-quick-view-fees-width',
    fakeInputAdditionalClass: 'application-quick-view-fees-width',
    required: true,
    tooltipText: t(FORM_FIELDS_NAMES.RISK_FEE_TOOLTIP),
    isLabelIcon: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.CHARGEBACK,
    fieldName: FORM_FIELDS.CHARGEBACK,
    label: t(FORM_FIELDS_NAMES.CHARGEBACK),
    placeholder: '0.00',
    inputType: InputType.Number,
    suffix: 'USD',
    additionalClasses: 'application-quick-view-fees-width',
    fakeInputAdditionalClass: 'application-quick-view-fees-width',
    required: true,
    tooltipText: t(FORM_FIELDS_NAMES.CHARGEBACK_TOOLTIP),
    isLabelIcon: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.REFUND_FEE,
    fieldName: FORM_FIELDS.REFUND_FEE,
    label: t(FORM_FIELDS_NAMES.REFUND_FEE),
    placeholder: '0.00',
    inputType: InputType.Number,
    suffix: 'USD',
    additionalClasses: 'application-quick-view-fees-width',
    fakeInputAdditionalClass: 'application-quick-view-fees-width',
    required: true,
    tooltipText: t(FORM_FIELDS_NAMES.REFUND_FEE_TOOLTIP),
    isLabelIcon: true,
    autoComplete: 'off'
  },

]);
